<div class="admin-tabs">
  <a
    class="admin-tabs__tab"
    [class.admin-tabs__tab--active]="active === 'contacts'"
    routerLink="/admin/contacts"
    (click)="onTabClick('contacts')">
    <mat-icon>group</mat-icon>
    Contacts
    @if (contactsCount !== null) {
      <span class="admin-tabs__count">{{ contactsCount }}</span>
    }
  </a>
  <a
    class="admin-tabs__tab"
    [class.admin-tabs__tab--active]="active === 'organisations'"
    routerLink="/admin/organisations"
    (click)="onTabClick('organisations')">
    <mat-icon>business</mat-icon>
    Organisations
    @if (organisationsCount !== null) {
      <span class="admin-tabs__count">{{ organisationsCount }}</span>
    }
  </a>
</div>
